import StateLabelView from './state-label-view'

export default StateLabelView
